<template>
  <v-container id="home-container" fluid fill-height>
      <HomeMainCards></HomeMainCards>
  </v-container>
</template>

<script>
import HomeMainCards from '../components/ui/HomeMainCards.vue'
export default {
  name: "Home",
  components: {
      HomeMainCards
  }
};
</script>

<style scoped>

</style>
